import React, { useContext, useState, useEffect } from "react";
import { LogIn } from "../API";

const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export const AuthProvider = ({ children }) => {
  const user = localStorage.getItem("user")?JSON.parse(localStorage.getItem("user")):null;
  console.log("Auth Provider: ",user);
  const [currentUser, setCurrentUser] = useState(user);

  function login(email, password, hospitalCode, roomNumber) {
    return LogIn({ email, password, hospitalCode, roomNumber })
      .then((res) => {
        setCurrentUser(res.data);
        localStorage.setItem("user", JSON.stringify(res.data));
        return res.data;
      })
      .catch((error) => {
        console.log("I am in errors in login")
        throw new Error(error.response.data.msg)
      });
  }

  function logout() {
    localStorage.removeItem("user");
    setCurrentUser(null);
  }

  const value = {
    currentUser,
    login,
    // signup,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
